import { useRentalManagerUserPropertyGetFieldsV2WebApiHandler_getPropertyFields } from '@zg-rentals/ts-rental-manager-api-client-react-query';

export const GET_PROPERTY_FIELDS_MUTATION_KEY = ['getPropertyFields'];

export const useGetPropertyFields = () => {
  return useRentalManagerUserPropertyGetFieldsV2WebApiHandler_getPropertyFields({
    mutationKey: GET_PROPERTY_FIELDS_MUTATION_KEY,
  });
};
